import type { BreadcrumbItem } from "@repo/ui";

/**
 * Sections d'une organisation, telles que la carte du dashboard les propose.
 * Le libellé est celui du fil d'Ariane ET du titre de la page : un seul nom
 * par écran, quel que soit le chemin qui y mène.
 */
const SECTIONS = {
  campagnes: "Campagnes",
  credits: "Crédits",
  scorecards: "Scorecards",
  users: "Utilisateurs",
  groupes: "Groupes",
  modifier: "Paramètres",
  corbeille: "Corbeille",
} as const;

export type SectionOrganisation = keyof typeof SECTIONS;

export const libelleSection = (section: SectionOrganisation) => SECTIONS[section];

/** Racine des URL d'une organisation, ou des données d'avant le multi-tenant. */
export const racineOrganisation = (organisationId: string | null | undefined) =>
  organisationId ? `/organisations/${organisationId}` : "/sans-organisation";

/**
 * Début commun du fil d'Ariane de toute page rattachée à une organisation :
 * `Organisations › {nom} › {section}`. Les pages plus profondes ajoutent leurs
 * propres segments à la suite.
 *
 * Le segment de l'organisation n'est pas cliquable : elle n'a pas de page à
 * elle, et le faire pointer vers une section arbitraire (les campagnes, avant)
 * surprenait quand on venait des crédits ou des utilisateurs. On remonte par
 * la section, ou jusqu'au dashboard.
 */
export function arianeOrganisation(
  organisationId: string | null | undefined,
  nom: string | null | undefined,
  section: SectionOrganisation,
): BreadcrumbItem[] {
  return [
    { label: "Organisations", href: "/" },
    { label: nom ?? (organisationId ? "Organisation" : "Sans organisation") },
    { label: SECTIONS[section], href: `${racineOrganisation(organisationId)}/${section}` },
  ];
}
